export enum UsernameType {
    Email = 'email',
    Phone = 'phone',
}
